export const stateCookiesSlug = [
  {
    slug: 'alabama',
    uri: '/medical-card/alabama/',
    cookie: 'AL',
  },
  {
    slug: 'alaska',
    uri: '/medical-card/alaska/',
    cookie: 'AK',
  },
  {
    slug: 'american-samoa',
    uri: '/medical-card/american-samoa/',
    cookie: 'AS',
  },
  {
    slug: 'arizona',
    uri: '/medical-card/arizona/',
    cookie: 'AZ',
  },
  {
    slug: 'colorado',
    uri: '/medical-card/colorado/',
    cookie: 'CO',
  },
  {
    slug: 'minnesota',
    uri: '/medical-card/minnesota/',
    cookie: 'MN',
  },
  {
    slug: 'california',
    uri: '/medical-card/california/',
    cookie: 'CA',
  },
  {
    slug: 'connecticut',
    uri: '/medical-card/connecticut/',
    cookie: 'CT',
  },
  {
    slug: 'delaware',
    uri: '/medical-card/delaware/',
    cookie: 'DE',
  },
  {
    slug: 'georgia',
    uri: '/medical-card/georgia/',
    cookie: 'GA',
  },
  {
    slug: 'kentucky',
    uri: '/medical-card/kentucky/',
    cookie: 'KY',
  },
  {
    slug: 'louisiana',
    uri: '/medical-card/louisiana/',
    cookie: 'LA',
  },
  {
    slug: 'maine',
    uri: '/medical-card/maine/',
    cookie: 'ME',
  },
  {
    slug: 'maryland',
    uri: '/medical-card/maryland/',
    cookie: 'MD',
  },
  {
    slug: 'massachusetts',
    uri: '/medical-card/massachusetts/',
    cookie: 'MA',
  },
  {
    slug: 'michigan',
    uri: '/medical-card/michigan/',
    cookie: 'MI',
  },
  {
    slug: 'mississippi',
    uri: '/medical-card/mississippi/',
    cookie: 'MS',
  },
  {
    slug: 'missouri',
    uri: '/medical-card/missouri/',
    cookie: 'MO',
  },
  {
    slug: 'montana',
    uri: '/medical-card/montana/',
    cookie: 'MT',
  },
  {
    slug: 'nevada',
    uri: '/medical-card/nevada/',
    cookie: 'NV',
  },
  {
    slug: 'new-hampshire',
    uri: '/medical-card/new-hampshire/',
    cookie: 'NH',
  },
  {
    slug: 'new-jersey',
    uri: '/medical-card/new-jersey/',
    cookie: 'NJ',
  },
  {
    slug: 'new-mexico',
    uri: '/medical-card/new-mexico/',
    cookie: 'NM',
  },
  {
    slug: 'new-york',
    uri: '/medical-card/new-york/',
    cookie: 'NY',
  },
  {
    slug: 'pennsylvania',
    uri: '/medical-card/pennsylvania/',
    cookie: 'PA',
  },
  {
    slug: 'puerto-rico',
    uri: '/medical-card/puerto-rico/',
    cookie: 'PR',
  },
  {
    slug: 'texas',
    uri: '/medical-card/texas/',
    cookie: 'TX',
  },
  {
    slug: 'utah',
    uri: '/medical-card/utah/',
    cookie: 'UT',
  },
  {
    slug: 'vermont',
    uri: '/medical-card/vermont/',
    cookie: 'VT',
  },
  {
    slug: 'virginia',
    uri: '/medical-card/virginia/',
    cookie: 'VA',
  },
  {
    slug: 'washington-d-c',
    uri: '/medical-card/washington-d-c/',
    cookie: 'DC',
  },
  {
    slug: 'west-virginia',
    uri: '/medical-card/west-virginia/',
    cookie: 'WV',
  },
  {
    slug: 'illinois',
    uri: '/medical-card/illinois/',
    cookie: 'IL',
  },
  {
    slug: 'iowa',
    uri: '/medical-card/iowa/',
    cookie: 'IA',
  },
  {
    slug: 'ohio',
    uri: '/medical-card/ohio/',
    cookie: 'OH',
  },
  {
    slug: 'oklahoma',
    uri: '/medical-card/oklahoma/',
    cookie: 'OK',
  },
  {
    slug: 'oregon',
    uri: '/medical-card/oregon/',
    cookie: 'OR',
  },
  {
    slug: 'guam',
    uri: '/medical-card/guam/',
    cookie: 'GU',
  },
  {
    slug: 'hawaii',
    uri: '/medical-card/hawaii/',
    cookie: 'HI',
  },
  {
    slug: 'idaho',
    uri: '/medical-card/idaho/',
    cookie: 'ID',
  },
  {
    slug: 'indiana',
    uri: '/medical-card/indiana/',
    cookie: 'IN',
  },
  {
    slug: 'kansas',
    uri: '/medical-card/kansas/',
    cookie: 'KS',
  },
  {
    slug: 'nebraska',
    uri: '/medical-card/nebraska/',
    cookie: 'NE',
  },
  {
    slug: 'north-carolina',
    uri: '/medical-card/north-carolina/',
    cookie: 'NC',
  },
  {
    slug: 'north-dakota',
    uri: '/medical-card/north-dakota/',
    cookie: 'ND',
  },
  {
    slug: 'northern-mariana-islands',
    uri: '/medical-card/northern-mariana-islands/',
    cookie: 'MP',
  },
  {
    slug: 'washington',
    uri: '/medical-card/washington/',
    cookie: 'WA',
  },
  {
    slug: 'arkansas',
    uri: '/medical-card/arkansas/',
    cookie: 'AR',
  },
  {
    slug: 'florida',
    uri: '/medical-card/florida/',
    cookie: 'FL',
  },
  {
    slug: 'rhode-island',
    uri: '/medical-card/rhode-island/',
    cookie: 'RI',
  },
  {
    slug: 'south-carolina',
    uri: '/medical-card/south-carolina/',
    cookie: 'SC',
  },
  {
    slug: 'south-dakota',
    uri: '/medical-card/south-dakota/',
    cookie: 'SD',
  },
  {
    slug: 'tennessee',
    uri: '/medical-card/tennessee/',
    cookie: 'TN',
  },
  {
    slug: 'us-virgin-islands',
    uri: '/medical-card/us-virgin-islands/',
    cookie: 'VI',
  },
  {
    slug: 'wisconsin',
    uri: '/medical-card/wisconsin/',
    cookie: 'WI',
  },
  {
    slug: 'wyoming',
    uri: '/medical-card/wyoming/',
    cookie: 'WY',
  },
];
